
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const PaystackSuccess = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const verify = async () => {
      const params = new URLSearchParams(window.location.search);
      const reference = params.get("reference") || params.get("trxref");

      if (!reference) {
        setError("Missing payment reference.");
        return;
      }

      try {
        const res = await fetch(
          `${API_URL}/api/subscription/verify-paystack-session?reference=${encodeURIComponent(reference)}`
        );
        const result = await res.json();

        if (!res.ok || !result.success) {
          throw new Error(result.message || "Payment verification failed");
        }

        // Same pattern your Stripe success flow presumably uses
        localStorage.setItem("token", result.token);
        sessionStorage.removeItem("pendingRegistration");

        navigate("/login"); // or straight to dashboard if you auto-log-in
      } catch (err) {
        console.error("Paystack verification error:", err);
        setError(err.message || "Something went wrong verifying your payment.");
      }
    };

    verify();
  }, []);

  if (error) {
    return <div>Payment verification failed: {error}. Please contact support.</div>;
  }

  return <div>Verifying your payment…</div>;
};

export default PaystackSuccess;